import React from 'react';
import styled from 'styled-components';
import success from '../../../imges/settled/success.png';

export default function () {
  return (
    <Container>
      <img src={success} alt='成功图片'/>
      <p>恭喜！提交成功！</p>
      <p>之后我们将会安排专人与您洽谈合作事宜，谢谢！</p>
    </Container>
  )
}

const Container = styled.div`
  text-align: center;
  margin-top: 0;
  img{
    width: 216px;
  }
  p:first-of-type{
    margin-top: 19px;
    color: #55A157;
    font-weight: bold;
    font-size: 20px;
    line-height: 36px;
  }
  p:nth-of-type(2){
    color: #726F6F;
    font-size: 16px;
    line-height: 36px;
  }
`